import { createReducer, createSelector, on } from "@ngrx/store";
import { loadMasterContactAddressesSuccess } from "./master-contact.actions";
import { MasterContactAddress } from "./models/MasterContactAddress";

export interface IMasterContactState {
    address: MasterContactAddress[];
}

export const initialMasterContactState: IMasterContactState = {
    address: []
};

export const masterContactReducer = createReducer(
    initialMasterContactState,
    on(loadMasterContactAddressesSuccess, (state, { addresses }) => {
        return {
            ...state,
            // address: addresses
        }
    })
);

export const selectMasterContactState = (state: any): IMasterContactState => state.MasterContactState;

export const selectMasterContactAddresses = createSelector(
    selectMasterContactState,
    (state) => state.address
);